import { ActionTree } from 'vuex';
import axios from 'axios';
import dialogGroups from './dialogGroups';
import animations from './animations';
import { dialog } from './dialog';
import { Howl, Howler } from 'howler';

let idleTimer;
let audioTimer;
let pollingTimer;
let noAnswerFoundCount = 0;
const TIMER_IDLE_MILLISECONDS = 180000;

const AVA_BOT_BASE_URL = 'https://directline.botframework.com/v3/directline/';
const AVA_BOT_GET_TOKEN_URL = AVA_BOT_BASE_URL + "tokens/generate";
const AVA_BOT_START_CONVERSATION_URL = AVA_BOT_BASE_URL + "conversations";
const AVA_BOT_SEND_ACTIVITY_URL = AVA_BOT_BASE_URL + "conversations/";
const AVA_BOT_GET_ACTIVITY_URL = AVA_BOT_BASE_URL + "conversations/{0}/activities?watermark={1}";
const AVA_AUDIO_URL = "audio/ava_responses-48.mp3";


let sound;

// !!!!!!!!!!!!!!!!!!!!!! Remove before production !!!!!!!!!!!!!!!!!!!!!!!!
// current production for SimCita
// const AVA_SECRET = "Bearer 7DdjXzVMNlw.cwA.hec.t59MybEXSACsNOSNyxvNBYA3RzluxQnvdbHNMEY44d0";
// const AVA_BOT_ID = "ava-prod-bot";
// dev-pmi-bot
const AVA_SECRET = "Bearer mKtD2RVOY1A.cwA.ZSs.qsQ3OxLjlMsaXSRUT3FhtQI59XnJoHnoMq2Kz2kqOLE";
const AVA_BOT_ID = "dev-pmi-bot";
let lastQuestion = '';

export const actions = {
    async fetchUserData({ commit }) {
        window.parent.postMessage(JSON.stringify({ event: "user_data" }), '*');

        let _user = {
            id: 1, avatar: 'http://master.sabercity.com/content/images/male_120.png', name: 'You'
        };
        commit('userLoaded', _user);


        window.addEventListener('message', function (e) {
            var _test = typeof (e.data);
            if (_test === "string") {
                let _data = JSON.parse(e.data);
                if (_data && _data.avatar) {
                    _user = _data;
                }
                commit('userLoaded', _user);
            }
        });

        function bindEvent(eventName, eventHandler) {
            window.addEventListener(eventName, eventHandler, false);
        }
    },
    async selectGroup({ dispatch, commit }, groupType) {
        dialogGroups.getDialogGroupByType(dialogGroup => {
            dispatch('changeSelectedGroup', dialogGroup);
        }, groupType)
    },
    async selectGroupByKey({ dispatch, commit }, key) {
        dialogGroups.getDialogGroupByKey(dialogGroup => {
            dialogGroup.comment.type = 'basic';
            dispatch('changeSelectedGroup', dialogGroup);
        }, key)
    },
    async selectOpeningGroup({ dispatch, commit }) {
        dialogGroups.getDialogGroupByType(dialogGroup => {
            dialogGroup.comment.type = 'basic';
            dispatch('changeSelectedGroup', dialogGroup);
        }, { groupType: 'opening' })
    },
    async selectPreOpeningGroup({ dispatch, commit }) {
        dialogGroups.getDialogGroupByType(dialogGroup => {
            dialogGroup.comment.type = 'basic';
            dispatch('changeSelectedGroup', dialogGroup);

        }, { groupType: 'idle-no-audio' })
    },
    loadAva({ dispatch, commit }) {
        sound = new Howl({
            mobileAutoEnable: false,
            src: [process.env.BASE_URL + AVA_AUDIO_URL],
            onplayerror: function () {
                console.log("play error");
            },
            onplay: function () {
                console.log("play");
            },
            onloaderror: function () {
                console.log("loaded error");
            },
            onunlock: function (e) {
                console.log("unlocked!" + e);
                //sound.play();
            },
            onload: function () {
                console.log("audio loaded.");
                commit('setIsReady', true)
            }
        });
        // sound.play();
    },
    startAva({ dispatch, commit }) {
        commit('setAllowSpeech');
        dispatch('selectOpeningGroup');
    },
    closeAva() {
        window.parent.postMessage(JSON.stringify({ event: "close" }), '*');
    },
    changeSelectedGroup({ dispatch, commit, state }, dialogGroup) {
        // mutate the selected group
        commit('groupSelected', dialogGroup);
        // call to play new ava animations
        dispatch('ava/playAnimations', dialogGroup.animations);

        // play audio if needed
        if (dialogGroup.length > 0) {
            dispatch('playAudio', { start: dialogGroup.audioStart, length: dialogGroup.length });
        }

        //start timer if needed.
        if (state.idleGroup !== 'idle-third') {
            dispatch('setIdleTimeOutTimer');
        }
    },
    playAudio({ dispatch, commit, state }, data) {
        dispatch('stopAudioTimer');
        sound.pause();
        sound.seek(data.start);
        sound.play();
        dispatch('setAudioTimeOut', data.length);
    },
    setAudioTimeOut({ commit }, length) {
        audioTimer = setTimeout(function () {
            sound.pause();
            // set flag to allow user to ask another question
            //commit('dialog/setWaitingForAnswer', false);
        }, length);
    },
    stopAudioTimer() {
        clearTimeout(audioTimer);
    },
    preloadAnimations() {
        animations.getAllAnimations(animations => {
            _.forEach(animations, function (animation) {
                var preloadLink = document.createElement("link");
                preloadLink.href = process.env.BASE_URL + 'ava/' + animation.file + '.gif';
                preloadLink.rel = "prefetch";
                preloadLink.as = "image";
                document.head.appendChild(preloadLink);
            });
        });
    },
    setIdleTimeOutTimer({ dispatch, state }) {
        // stop timer if set
        dispatch('stopIdleTimer');
        idleTimer = setTimeout(function () {
            dialogGroups.getDialogGroupByType(dialogGroup => {
                dialogGroup.comment.type = 'basic';
                dispatch('changeSelectedGroup', dialogGroup);
                dispatch('changeIdleGroup', 'up');
            }, { groupType: state.idleGroup })
        }, TIMER_IDLE_MILLISECONDS);
    },
    stopIdleTimer() {
        clearTimeout(idleTimer);
    },
    changeIdleGroup({ dispatch, commit, state }, direction) {
        // start a new timer if not the third idle
        if (state.idleGroup !== 'idle-third') {
            dispatch('setIdleTimeOutTimer');
        }
        if (direction === 'up') {
            commit('setIdleGroup', state.idleGroup === 'idle-first' ? 'idle-second' : 'idle-third');
        }
        if (direction === 'reset') {
            commit('setIdleGroup', 'idle-first');
        }
    },
    startConversation({ commit }) {
        let vm = this;
        axios({
            method: 'post',
            url: AVA_BOT_START_CONVERSATION_URL,
            headers: { 'Authorization': AVA_SECRET }
        }).then(function (response) {
            commit('setConversationData', response.data);
        }).catch(e => {
            console.log('error: ' + e.message);
        });

    },
    sendQuestion({ dispatch, commit, state }, searchText) {
        // set lastquestion variable in case question is not answered
        this.lastQuestion = searchText;
        // stop idle timer
        dispatch('stopIdleTimer');
        // clear text box
        commit('updateAskAvaQuestion', '');
        axios({
            method: 'post',
            url: AVA_BOT_SEND_ACTIVITY_URL + state.conversationId + '/activities',
            headers: { 'Authorization': 'Bearer ' + state.avaToken },
            data: {
                "type": "message",
                "from": {
                    "id": "user1"
                },
                "text": searchText
            }
        }).then(function (response) {
            if (state.watermark > 0) {
                commit('setWaterMark', (parseInt(state.watermark) + 1));
            }
            commit('setActivityId', response.data.id);
            dispatch('startAnswerPollingTimer');
        }).catch(e => {
            clearTimeout(pollingTimer);
            dispatch('createAndCommitErrorCard');
        });
        dispatch('createAndCommitQuestionGroup', searchText);
    },
    startAnswerPollingTimer({ dispatch, commit, state }) {
        clearTimeout(pollingTimer);
        pollingTimer = setTimeout(function () {
            dispatch('getAnswer');
        }, 300);

    },
    stopPollingTimer() {
        clearTimeout(pollingTimer);
    },
    getAnswer({ dispatch, commit, state }) {
        let vm = this;
        axios({
            method: 'get',
            url: AVA_BOT_SEND_ACTIVITY_URL + state.conversationId + '/activities?watermark=' + state.watermark,
            headers: { 'Authorization': 'Bearer ' + state.avaToken }
        }).then(function (response) {
            if (response.data.activities.length > 0) {
                commit('setWaterMark', response.data.watermark);
                var activities = response.data.activities;

                let avaResponses = _.filter(activities, function (a) {
                    return a.from.id === AVA_BOT_ID;
                });
                if (avaResponses && avaResponses.length >= 1) {
                    _.forEach(avaResponses, function (activity) {
                        dispatch('parseActivites', activity);
                    });
                } 
                //dispatch('parseActivites', activities);
                clearTimeout(pollingTimer);
            } else {
                if (parseInt(response.data.watermark) !== state.watermark) {
                    dispatch('startAnswerPollingTimer');
                }    
            }
        }).catch(e => {
            clearTimeout(pollingTimer);
            vm.dispatch('createAndCommitErrorCard');
        });
    },
    parseActivites({ dispatch, commit, state }, activity) {
        // basic card
        if (activity.text.length > 0) {
            if (activity.text === 'No good match in FAQ.') {           
                dispatch('handleNoAnswer');
                if (noAnswerFoundCount > 0) {
                    noAnswerFoundCount++;
                    dispatch('createAndCommitNoAnswerCard2', '');
                }
                if (noAnswerFoundCount === 0) {
                    noAnswerFoundCount++;
                    dispatch('createAndCommitNoAnswerCard', '');
                }
                
            } else {
                dispatch('createAndCommitBasicCard', activity.text);
            }
        } else { // get card type to parse correctly
            switch (activity.attachments[0].contentType) {
                case 'application/vnd.microsoft.card.hero':
                    dispatch('createAndCommitHeroCard', activity.attachments[0].content);
                    break;
                case 'application/vnd.microsoft.card.thumbnail':
                    dispatch('createAndCommitThumbnailCard', activity.attachments[0].content);
                    break;
                case 'application/vnd.microsoft.card.video':
                    dispatch('createAndCommitVideoCard', activity.attachments[0].content);
                    break;
                default:
                //TODO
            }
        }
    },
    createAndCommitQuestionGroup({ dispatch, commit, state }, question) {
        dialogGroups.getDialogGroupByType(dialogGroup => {
            dialogGroup.comment.text = question;
            dialogGroup.comment.type = 'question';
            dispatch('changeSelectedGroup', dialogGroup);
            dispatch('changeIdleGroup', 'reset');
        }, { groupType: 'question' });
    },
    createAndCommitNoAnswerCard({ dispatch, commit, state }) {
        dialogGroups.getDialogGroupByType(dialogGroup => {
            dialogGroup.comment.type = 'basic';
            dispatch('changeSelectedGroup', dialogGroup);
        }, { groupType: 'noanswer1' });
    },
    createAndCommitNoAnswerCard2({ dispatch, commit, state }) {
        dialogGroups.getDialogGroupByType(dialogGroup => {
            dialogGroup.comment.type = 'basic';
            dispatch('changeSelectedGroup', dialogGroup);
        }, { groupType: 'noanswer2' });
    },
    createAndCommitBasicCard({ dispatch, commit, state }, answer) {
        dialogGroups.getDialogGroupByType(dialogGroup => {
            if (answer && answer.length > 0) {
                //split the answer on | and the first string is the title and the second is the text
                let _answer = answer.split('|');
                dialogGroup.comment.title = _answer[0];
                dialogGroup.comment.answer = (_answer.length === 2) ? _answer[1] : '';
            }
            dialogGroup.comment.type = 'basic';
            dispatch('changeSelectedGroup', dialogGroup);
        }, { groupType: 'answer' });
    },
    createAndCommitHeroCard({ dispatch, commit, state }, answer) {
        dialogGroups.getDialogGroupByType(dialogGroup => {
            dialogGroup.comment.answer = '';
            dialogGroup.comment.type = 'hero';
            dialogGroup.comment.content = answer;
            dispatch('changeSelectedGroup', dialogGroup);
        }, { groupType: 'answer' });
    },
    createAndCommitThumbnailCard({ dispatch, commit, state }, answer) {
        dialogGroups.getDialogGroupByType(dialogGroup => {
            dialogGroup.comment.answer = '';
            dialogGroup.comment.type = 'thumbnail';
            dialogGroup.comment.content = answer;
            dispatch('changeSelectedGroup', dialogGroup);
        }, { groupType: 'answer' });
    },
    createAndCommitVideoCard({ dispatch, commit, state }, answer) {
        dialogGroups.getDialogGroupByType(dialogGroup => {
            dialogGroup.comment.answer = '';
            dialogGroup.comment.type = 'video';
            dialogGroup.comment.content = answer;
            dispatch('changeSelectedGroup', dialogGroup);
        }, { groupType: 'answer' });
    },
    createAndCommitErrorCard({ dispatch, commit, state }) {
        dialogGroups.getDialogGroupByType(dialogGroup => {
            dialogGroup.comment.type = 'basic';
            dispatch('changeSelectedGroup', dialogGroup);
            dispatch('changeIdleGroup', 'reset');
        }, { groupType: 'error' });
    },
    handleNoAnswer({ dispatch, state }) {
        let website = '';
        if (parent !== window) {
            website = document.referrer;
        }

        let _postBody = {
            Question: this.lastQuestion,
            DateAsked: new Date(),
            Website: website,
            FirstName: state.user.firstName,
            LastName: state.user.lastName,
            Email: state.user.email,
            Reviewed: false
        };

        axios.post(`https://prod-ava-unanswer-quest-func.azurewebsites.net/api/SaveUnasweredAvaQuestionsV2?code=N/sy4b49Mi9nMxCf5209OG9FII7FLGF4ei6rKtTJWiFO0jSUMfsVFA==`,  _postBody)
            .then(response => { })
            .catch(e => {
                //this.errors.push(e);
            });
    }

};
